// extracted by mini-css-extract-plugin
export default {"containerDashboardP":"TabelaEKategorive_containerDashboardP__gL0Zy"};